import React, {FC, memo} from "react";
import {Col} from "react-bootstrap";
import {Title} from "./MainLabelStyle";
import {useNavigate} from "react-router-dom";
import {config} from "../../config";

const MainLabel: FC = () => {
    const nav =useNavigate()
    return (
        <Title onClick={() => nav(`${config.uiStart}/`)}>
            <Col>
                <span style={{color: "black"}}>H</span>
                <span style={{color: "red"}}>0</span>
                <span style={{color: "black"}}>M</span>
                <span style={{color: "red"}}>E</span>
                <span>-</span>
                <span style={{color: "black"}}>U</span>
                <span style={{color: "red"}}>I</span>
            </Col>
        </Title>
    )
}

export default memo(MainLabel);
